import request from '@/utils/http/request'

/* 首頁相關接口 */

/**
  * 首頁數據
  * @returns {Object} - 首頁數據對象
  */
export async function home() {
  return await request.post('/home', {}, {
    noAuth: true
  });
}


/**
  * 臨近場館
  *  @param {*} latitude - 緯度
  *  @param {*} longitude - 經度
  * @returns {Object} - 場館數據對象
  */
export async function gyms({ latitude, longitude }) {
  return await request.post('/home/gyms/list', {
    location: {
      latitude,
      longitude
    }
  }, {
    noAuth: true
  });
}


/**
 * 品牌專區列表
 * @returns 
 */
export async function brand_activityList({ pageSize, pageNumber }) {
  return await request.post(`/home/brandActivityList`, { pageSize, pageNumber });
}


/** 
 * 品牌商戶列表

 * */
export async function mchInfos() {
  return await request.post(`/mchInfos`);
}

/* 聯繫我們 */
export async function contactUs({ fullName, contactNumber, contactContent, email }) {
  return await request.post(`/contactUs`, { fullName, contactNumber, contactContent, email });
}